import React, { ReactElement, ReactNode } from 'react';
import { EmptyStateSize, useEmptyStateSizeContext } from '../contexts/size';
import { MenuIcons } from '../default-icons';
import { EmptyStateIcon } from './empty-state-icon';

interface EmptyStateMenuIconProps {
  className?: string;
  children?: ReactNode;
  icon?: ReactElement;
}

const fallbackIcon = MenuIcons.CloudDismiss;

export const EmptyStateMenuIcon = ({
  className,
  children,
  icon,
}: EmptyStateMenuIconProps) => {
  const { size } = useEmptyStateSizeContext();

  if (size !== EmptyStateSize.mediumMenu && size !== EmptyStateSize.smallMenu) {
    throw new Error('The menu icon component can only be used with the medium menu & small menu sizes.');
  }

  return (
    <EmptyStateIcon
      className={className}
      fallbackIcon={fallbackIcon}
      icon={icon}
    >
      {children}
    </EmptyStateIcon>
  );
};
